<template>
	<section class="logo">
		<img src="./img/logo.png" alt="" />
	</section>
</template>

<script>
	
	export default {
		data() {
			return {
				
	            }
		},
		mounted: function() {
			this.$nextTick(function() {
				
			})
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	.logo {
		padding: 15px 0;
	    margin-bottom: 60px;
	}
</style>


// WEBPACK FOOTER //
// logo_head.vue?96bb0f60